const notPossibleEn = {
  'notPossible': {
    'title': {
      'operation': 'The operation is not possible',
      'authorization': 'You can not log in',
    },
    'description': 'There are no session keys available to confirm the operation.\nTo obtain a new set of keys, contact your nearest bank branch.\nYou can change the transaction confirmation to SMS through the Information Center.',
  },
};

export default notPossibleEn;
